// CustomHeaders.js
import { formatDateWithAmPm, getStatusClass } from "../../Style";

export const customHeaders = [
  { field: "customerId", header: "Customer Id" },
  {
    field: "fullName",
    header: "Full Name",
    render: (_, row) => row?.fullName ?? "Unknown Name"
  },
  { field: "email", header: "Email" },
  { field: "mobile", header: "Mobile" },
  {
    field: "lastActive",
    header: "Last Active",
    render: (value) => formatDateWithAmPm(value)
  },
  {
    field: "createdDate",
    header: "Created Date",
    render: (value) => formatDateWithAmPm(value)
  },
  {
    field: "status",
    header: "Status",
    render: (value) => (
      <span className={`badge ${getStatusClass(value)}`}>{value}</span>
    )
  }
];
